<template>
    <el-card>
        <el-page-header @back="close" content="角色信息"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form ref="form" :model="form" :rules="rules" :status-icon="true" label-width="100px">
                    <el-form-item label="描述" prop="description">
                        <el-input v-model="form.description" maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <RemoteSelect v-model="form.status" :options="$utils.getEnumOptions('status')" style="width: 200px"></RemoteSelect>
                    </el-form-item>
                    <el-form-item label="权限配置" prop="status">
                        <el-card>
                            <el-tree ref="tree" :data="treeData"
                                     :default-checked-keys="checkedKeys" :default-expanded-keys="expandedKeys"
                                     accordion show-checkbox node-key="value">
                                <div class="el-tree-node__label" slot-scope="{node, data}">
                                    <span>{{node.label}}</span>&nbsp;&nbsp;
                                    <el-tag size="mini" v-if="data.type === 'LINK'">{{$utils.getEnumLabel('permission.type', data.type)}}</el-tag>
                                </div>
                            </el-tree>
                        </el-card>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </el-card>
</template>

<script>
    import RemoteSelect from "@/components/RemoteSelect";

    export default {
        components: {
            RemoteSelect
        },
        props: ["id"],
        data() {
            return {
                form: {
                    status: "ENABLE"
                },
                rules: {
                    description: [{required: true, message: "请填写角色描述"}],
                },
                permissions: [],
                treeData: []
            };
        },
        beforeMount() {
            if (this.id > 0) {
                this.$axios.get("/role/get/" + this.id).then(response => {
                    this.form = response.data;
                });
            }
            this.$axios.post("/permission/visible", {
                orders: {
                    "ordered": "asc"
                }
            }).then(response => {
                this.permissions = response.data;

                if (this.$root.user.type === 'TENANT') {
                    // 不可分配系统管理权限
                    this.treeData = this.getChildren(0).filter(node => node['value'] > 1);
                } else {
                    this.treeData = this.getChildren(0);
                }
            })
        },
        computed: {
            expandedKeys() {
                if (this.treeData.length > 0) {
                    return [this.treeData[0]['value']];
                }
                return [];
            },
            checkedKeys() {
                let permissions = [];
                if (this.form.permissions) {
                    this.form.permissions.forEach(id => {
                        // 解决父节点半选显示问题
                        if (this.getChildren(id).length === 0) {
                            permissions.push(id);
                        }
                    });
                }
                return permissions;
            }
        },
        methods: {
            getChildren(id) {
                let children = [];
                this.permissions.forEach(permission => {
                    if (permission['parentId'] === id) {
                        children.push({
                            label: permission['name'],
                            value: permission['id'],
                            type: permission['type'],
                            children: this.getChildren(permission['id'])
                        });
                    }
                });
                return children;
            },
            submit() {
                let checkedKeys = this.$refs.tree.getCheckedKeys(false, true);
                let halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys(false, true);
                let data = this.$utils.clone(this.form);
                data.permissions = halfCheckedKeys.concat(checkedKeys);

                let url = this.form.id ? "/role/edit" : "/role/save";
                this.$utils.submit(this.$refs.form, url, data, () => {
                    this.$emit("close", true);
                });
            },
            close() {
                this.$emit("close", false);
            },
        },
    }
</script>